<template>
  <div>
    <div>
      <BaseList
          ref="pageRef"
          page-title="下载中心"
          page-index-key="pageNo"
          :actions="actionBtns"
          :module-name="moduleName"
          :column-options="columnOptions"
          search-btn-name="查询"
          :fetch-data-api="queryByPageDownload"
      />
    </div>
  </div>
</template>
<script>

import BaseList from '@/components/baseList';
import {queryByPageDownload} from "@/api/downloadCenter";

export default {
  components: {
    BaseList
  },

  data() {
    return {
      moduleName: 'donwloadCenter',
      columnOptions: {
        sumColumnKeys: []
      },
    }
  },

  computed: {
    actionBtns() {
      return []
    },
  },

  methods: {
    queryByPageDownload,
    /**
     * @description 刷新页面
     */
    pageRefresh() {
      this.$refs.pageRef.refresh()
    },

  },
}
</script>
